// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyFeedbackResponse
 */
export interface DailyFeedbackResponse {
    /**
     * 
     * @type {Date}
     * @memberof DailyFeedbackResponse
     */
    day: Date;
    /**
     * 
     * @type {number}
     * @memberof DailyFeedbackResponse
     */
    positive: number;
    /**
     * 
     * @type {number}
     * @memberof DailyFeedbackResponse
     */
    negative: number;
}

/**
 * Check if a given object implements the DailyFeedbackResponse interface.
 */
export function instanceOfDailyFeedbackResponse(value: object): value is DailyFeedbackResponse {
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('positive' in value) || value['positive'] === undefined) return false;
    if (!('negative' in value) || value['negative'] === undefined) return false;
    return true;
}

export function DailyFeedbackResponseFromJSON(json: any): DailyFeedbackResponse {
    return DailyFeedbackResponseFromJSONTyped(json, false);
}

export function DailyFeedbackResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyFeedbackResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'day': (new Date(json['day'])),
        'positive': json['positive'],
        'negative': json['negative'],
    };
}

export function DailyFeedbackResponseToJSON(json: any): DailyFeedbackResponse {
    return DailyFeedbackResponseToJSONTyped(json, false);
}

export function DailyFeedbackResponseToJSONTyped(value?: DailyFeedbackResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'day': value['day'].toISOString().substring(0,10),
        'positive': value['positive'],
        'negative': value['negative'],
    };
}

